import { Checkbox, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutUserLogin extends Layout {
    checkboxAllowNewDevices: Checkbox;
    labelDevices: Label;
    sourceUserRecognizedDevice: DataSource;
    sourceUserSettings: DataSource;
    tableUserDevices: Table;
}
